<template>
  <b-modal ref="modal-simulador" centered body-class="pb-2" footer-class="d-flex">
    <!--HEADER MODAL -->
    <template v-slot:modal-header>
      <div class="row ml-0">
        <!-- logo mineduc-->
        <div class="logo col-3 pl-0 mt-n3">
          <img
            class="img-fluid pr-lg-4"
            src="@/assets/img/logo-tope-subesup-mineduc3.png"
            alt="Ministerio de Educación"
          />
        </div>

        <div class="col-12 offset-4 mt-n3 pl-3">
          <img
            src="@/assets/img/logo_acceso2.svg"
            class="logo-acceso img-fluid w-25"
            alt="logo ACCESO a la Educación Superior"
          />
        </div>
      </div>

      <button type="button" class="close" @click="hideModal">
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <!--BODY MODAL -->
    <form>
      <InputRutWrapper ref="rut" v-model="form.run" />
      <InputTextWraper
        id="nombre"
        v-model="form.nombre"
        type="text"
        maxlength="40"
        placeholder="Nombre Completo"
        :estado="tieneError('nombre')"
        :mensajeError="mensajeError('nombre')"
        @keyup="validarNombre"
      />
      <InputTextWraper
        id="correo"
        v-model="form.mail"
        type="email"
        maxlength="40"
        placeholder="Correo Electrónico"
        :estado="tieneError('correo')"
        :mensajeError="mensajeError('correo')"
        @keyup="validarCorreo"
      />
      <br />
      <div class="input-group">
        <b-form-checkbox
          v-model="checkTerminos"
          name="checkTerminos"
          size="sm"
          @change="validarTerminos"
        >
          <strong>
            Estoy de acuerdo con los <a
              href="https://acceso.mineduc.cl/wp-content/uploads/2020/07/TERMINOS_Y_CONDICIONES_USO_WEB_ACCESO.pdf"
              target="_blank"
            >términos y condiciones</a> de uso de información de
            <a
              href="https://acceso.mineduc.cl/"
            >acceso.mineduc.cl</a>
          </strong>
        </b-form-checkbox>
        <b-form-invalid-feedback :state="stateTerminos">Debe aceptar los términos y condiciones.</b-form-invalid-feedback>
      </div>
    </form>
    <!--FOOTER MODAL-->
    <template v-slot:modal-footer>
      <div class="col px-0">
        <!--<button
          class="btn btn-negro w-100 rounded-0 enviar"
          type="button"
          id="inputGroupFileAddon2"
          @click="enviar"
        >Enviar</button>-->
        <InvisibleRecaptcha
          id="inputGroupFileAddon2"
          data-test="button-solicitar-simulacion"
          :sitekey="siteKey"
          :validate="validarCampos"
          :callback="enviarInformacion"
          theme="light"
          class="btn btn-negro w-100 rounded-0 enviar"
          :disabled="false"
          type="submit"
        >ENVIAR</InvisibleRecaptcha>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputTextWraper from "@/components/generales/modales/InputTextWrapper";
import InputRutWrapper from "@/components/generales/modales/InputRutWrapper";
import {
  MensajesDeRespuesta,
  MensajesDeCarga
} from "@/utils/BusesDeEventos.js";
import ManejoErrores from "@/mixins/manejoErrores";
import { validacion } from "@/utils/ValidacionGenerica";
import { mapGetters, mapActions } from "vuex";
import ApiUniversidades from "@/services/ApiUniversidades";
import InvisibleRecaptcha from "@/components/recaptcha/InvisibleRecaptcha";
import { EventBus } from "@/assets/js/EventBus";
export default {
  name: "solicitarSimulacion",
  components: {
    InputTextWraper,
    InputRutWrapper,
    InvisibleRecaptcha
  },
  props: {},
  mixins: [ManejoErrores],
  data() {
    return {
      form: {
        run: "",
        nombre: "",
        mail: ""
      },
      config: {
        headers: {}
      },
      checkTerminos: false,
      stateTerminos: null,
      siteKey: RECAPTCHA_PUBLIC_KEY
    };
  },
  created() {
    EventBus.$on("verifyCaptcha", token => {
      this.enviarInformacion(token);
    });
  },
  computed: {
    ...mapGetters(["getDataSimulacion", "getBotonCaptcha"])
  },
  methods: {
    ...mapActions(["setBotonCaptcha"]),
    validarRun() {
      return this.$refs.rut.validacionRun();
    },
    validarTerminos(val) {
      if (val) {
        this.stateTerminos = null;
      } else {
        this.stateTerminos = false;
      }
      return this.checkTerminos;
    },
    validarNombre() {
      let flag = true;
      this.limpiarError("nombre");
      if (this.form.nombre.length < 1) {
        flag = false;
        this.guardarError("nombre", "Campo obligatorio");
      } else if (validacion("", this.form.nombre, "^[a-zA-Z'-\\s]*$")) {
        flag = false;
        this.guardarError("nombre", "Debe indicar un nombre válido");
      }
      return flag;
    },
    validarCorreo() {
      let flag = true;
      this.limpiarError("correo");
      if (this.form.mail.length < 1) {
        flag = false;
        this.guardarError("correo", "Campo obligatorio");
      } else if (validacion("CORREO", this.form.mail)) {
        flag = false;
        this.guardarError(
          "correo",
          "Debe indicar un correo electrónico válido"
        );
      }
      return flag;
    },
    validarCampos() {
      MensajesDeCarga.$emit("cargar");
      this.setBotonCaptcha("MODAL");
      this.modificado = ["run", "nombre", "correo"];
      let valido = [
        this.validarRun(),
        this.validarNombre(),
        this.validarCorreo(),
        this.validarTerminos(this.checkTerminos)
      ];
      let validado = true;
      if (valido.includes(false)) {
        validado = false;
        MensajesDeCarga.$emit("cargado");
      }
      return validado;
    },
    enviarInformacion(recaptchaToken) {
      if (recaptchaToken && this.getBotonCaptcha === "MODAL") {
        this.$ga.event({
        eventCategory: "Sistema-Acceso",
        eventAction: "simulador-ponderaciones",
        eventLabel: "enviar-simulacion-correo"
      });
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.enviarFormulario();
      }
    },
    eliminarNull(objeto) {
      let llaves = Object.keys(objeto);
      for (let llave of llaves) {
        if (!objeto[llave]) {
          delete objeto[llave];
        }
      }
      return objeto;
    },
    async enviarFormulario() {
      MensajesDeCarga.$emit("cargar");
      let dataSimulada = this.getDataSimulacion;
      let data = {
        nem: this.adaptarData(dataSimulada.nem, "NUMERO"),
        ranking: this.adaptarData(dataSimulada.ranking, "NUMERO"),
        lenguaje: this.adaptarData(dataSimulada.lenguaje, "NUMERO"),
        matematicas: this.adaptarData(dataSimulada.matematicas, "NUMERO"),
        historia: this.adaptarData(dataSimulada.historia, "NUMERO"),
        ciencias: this.adaptarData(dataSimulada.ciencias, "NUMERO"),
        region: this.adaptarData(dataSimulada.region, "CARACTER"),
        nombreInstitucion: this.adaptarData(
          dataSimulada.nombreInstitucion,
          "CARACTER"
        ),
        nombreCarreraGenerico: this.adaptarData(
          dataSimulada.nombreCarreraGenerico,
          "CARACTER"
        ),
        nombre: this.form.nombre,
        mail: this.form.mail,
        pasaporte: this.adaptarData(this.form.run, "PASAPORTE"),
        run: this.adaptarData(this.form.run, "RUT")
      };
      this.eliminarNull(data);
      let respuesta = await ApiUniversidades.enviarSimulacionCorreo(
        data,
        this.config
      );
      if (respuesta === "") {
        this.hideModal();
        this.mostrarMensajeExito();
        this.limpiarDatos();
      }
      this.setBotonCaptcha("");
      MensajesDeCarga.$emit("cargado");
    },
    adaptarData(data, tipo) {
      switch (tipo) {
        case "NUMERO":
          return data === null || data === "" ? null : parseInt(data, 10);
          break;
        case "CARACTER":
          return data === null || data === "" || data === "TODAS" ? null : data;
          break;
        case "RUT":
          let rut = this.$refs.rut.separarRun(data);

          return this.$refs.rut.getTipoDocumento() === "RUT"
            ? `${rut.run}-${rut.digitoVerificador}`
            : null;
          break;
        case "PASAPORTE":
          return this.$refs.rut.getTipoDocumento() === "PASAPORTE"
            ? data
            : null;
          break;
        default:
          return data === null || data === "" ? null : data;
          break;
      }
    },
    showModal() {
      this.$refs["modal-simulador"].show();
    },
    hideModal() {
      this.$refs["modal-simulador"].hide();
      this.limpiarError("nombre");
      this.limpiarError("correo");
      this.stateTerminos = null;
      this.limpiarDatos();
      EventBus.$off("verifyCaptcha", token => {
        this.enviarInformacion(token);
      });
    },
    limpiarDatos() {
      this.form.run = "";
      this.form.nombre = "";
      this.form.mail = "";
      this.checkTerminos = false;
      this.stateTerminos = null;
    },
    mostrarMensajeExito() {
      MensajesDeRespuesta.$emit("respuestaEnvio", true);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/modales/SolicitarSimulacion.vue